export const API_KEY = "AIzaSyC9kgNRqqTOPSFsZrnaMDX3eqH3yNGomxo";

export default API_KEY;

// 7cd01d6782b948dc0
